import { isExperimentalFeatureEnabled } from '..';
export function getEventBridge() {
    var datadogEventBridge = getEventBridgeGlobal();
    return {
        send: function (eventType, event) {
            datadogEventBridge === null || datadogEventBridge === void 0 ? void 0 : datadogEventBridge.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
export function isEventBridgePresent() {
    return !!getEventBridgeGlobal();
}
function getEventBridgeGlobal() {
    return isExperimentalFeatureEnabled('event-bridge') ? window.DatadogEventBridge : null;
}
//# sourceMappingURL=eventBridge.js.map